/**
 * Shared handler for terminal auth failures (expired/revoked session).
 * Registered from AuthProvider so API clients can clear state and bounce
 * to login without waiting for a React re-render.
 */

let sessionExpiredHandler: (() => void) | null = null;
let sessionExpiredHandling = false;

export function setSessionExpiredHandler(handler: (() => void) | null): void {
  sessionExpiredHandler = handler;
  // Allow a fresh redirect after remount / handler swap.
  sessionExpiredHandling = false;
}

/** Clear session and redirect to login. Safe to call repeatedly — runs once. */
export function handleSessionExpired(): void {
  if (sessionExpiredHandling) return;
  sessionExpiredHandling = true;
  try {
    sessionExpiredHandler?.();
  } catch (error) {
    console.error("Session-expired handler failed:", error);
  }
}
